module.exports = __webpack_public_path__ + "static/media/billing_area_logo.82aa2ebc.svg";